import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SendPaymentInstructionModelService } from '@pg-app/client/send-payment-instruction/services/send-payment-instruction.model.service';
import { DownloadTypeEnum } from '@nttp/enum/download-type-enum';
import { SendPaymentInstructionService } from '@pg-app/client/send-payment-instruction/services/send-payment-instruction.service';
import { UtilityService } from '@nttp/common-service/utility-service';
import { DownloadFileTypeEnum } from '@nttp/enum/download-file-type-enum';
import { RegistrationStep2Service } from '@pg-app/client/services/registrationStep2.service';

@Component({
  selector: 'np-payment-complete',
  templateUrl: './payment-complete.component.html',
  styleUrls: ['./payment-complete.component.scss']
})
export class PaymentCompleteComponent implements OnInit {

  constructor(
    private dialog: MatDialog,
    private paymentModel: SendPaymentInstructionModelService,
    private sendPaymentService: SendPaymentInstructionService,
    private utilityService: UtilityService,
    public clientInfo: RegistrationStep2Service,
  ) { }

  ngOnInit(): void {
  }

  public completeSendpayment() {
    this.dialog.closeAll();
    window.location.reload();
  }

}
